import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";

const API_URL = import.meta.env.VITE_API_URL;

const BoShowAgentReport = () => {
    const {boData, verifySyncUrl} = useContext(BoShowContext);
    const gcmReport = boData?.gcmReport;
    const gcmReportComplementList = boData?.gcmReportComplementList;
    const signatureId = boData?.gcmReportSignature?.attachId;

    if (!gcmReport && !gcmReportComplementList?.length) return null;

    return (
        <article className={"space-y-4"}>
            <h2 className={"resume-title"}>RELATÓRIO DO AGENTE</h2>

            {
                gcmReport &&
                <div className={"info whitespace-pre-wrap text-justify"}>{gcmReport}</div>
            }

            {
                !!gcmReportComplementList?.length &&
                <section className={"space-y-2"}>
                    <h3 className={"font-semibold text-center"}>Complementos</h3>

                    <div className={"space-y-3"}>
                        {
                            gcmReportComplementList.map((item, index) => (
                                <div key={item?.itemId ?? index} className={"space-y-1"}>
                                    <strong>{item?.date ?? ""}</strong>
                                    <p className={"info whitespace-pre-wrap"}>{item?.complement ?? ""}</p>
                                </div>
                            ))
                        }
                    </div>
                </section>
            }

            {
                signatureId &&
                <section className={"space-y-2"}>
                    <h3 className={"!font-normal text-center"}>Assinatura</h3>

                    <div className={"image max-w-xs mx-auto"}>
                        <img src={`${API_URL}/attach/${signatureId}`} alt={"Assinatura do relatório"}/>
                    </div>
                </section>
            }
        </article>
    );
};

export default BoShowAgentReport;
